import { ServiceError } from 'services/errors/ServiceError'

export type NotFoundErrorPayload =
  | Error
  | {
      [key: string]: unknown
      message: string
      url: string
    }

export class NotFoundError extends ServiceError {
  constructor(payload: NotFoundErrorPayload, info?: Error) {
    super({ status: 404, ...payload }, info)
    this.name = 'NotFoundError'
  }
}
